define(
	'Code25.CaterpartsGlobal.SO', [
	'jQuery', 'underscore', 'Utils', 'ListHeader.View','AjaxRequestsKiller'
],
	function (
		jQuery, _, Utils, ListHeaderView,AjaxRequestsKiller
	) {
		'use strict';

		return {
			mount: function (container) {


				var layout = container.getComponent('Layout');

				if (layout) {


					if (SC.ENVIRONMENT.SCTouchpoint == "myaccount") {

						ListHeaderView.prototype.events['blur [data-action="so-filter"]'] = 'soFilterBlur';
						ListHeaderView.prototype.events['keyup [data-action="so-filter"]'] = 'soFilterKey';

						_.extend(ListHeaderView.prototype, {


							soFilterBlur : function (e) {
								this.currentSearch=e.currentTarget.value;
								this.updateCollection();
	
							},
							soFilterKey : function (e) {
								if (e.key == "Enter") {
									this.soFilterBlur(e);
								}
							}
							,updateCollection: function() {
								// console.log("updateCollection");
								var range = null;
								var collection = this.collection;
						
								if (this.selectedRange) {
									// @class RangeFilter
									// If there is no date selected i keep the range empty in order
									// to get "transactions" dated in the future
									range = {
										// @property {String} from
										from:
											this.selectedRange.from ||
											(this.allowEmptyBoundaries ? '' : this.rangeFilterOptions.fromMin),
										// @property {String} to
										to:
											this.selectedRange.to ||
											(this.allowEmptyBoundaries ? '' : this.rangeFilterOptions.toMax)
									};
								}
						
								// @lass Collection.Filter
								collection.update &&
									collection.update(
										{
											search:this.currentSearch,
											// @property {value:String} filter
											filter: this.selectedFilter,
											// @property {RangeFilter} range
											range: range,
											// @property {value:String} sort
											sort: this.selectedSort,
											// @property {String} order
											order: this.order,
											page: this.page,
											// @property {Number} killerId
											killerId: AjaxRequestsKiller.getKillerId()
										},
										this
									);
						
								// @class ListHeader.View
								return this;
							}
							,getContext: _.wrap(ListHeaderView.prototype.getContext, function (getContext) {
	
	
								var res = getContext.apply(this, _.rest(arguments));
	
								res.currentSearch=this.currentSearch;
								return res;
	
							})
						});



						
						
						var update=function(options) {
							var range = options.range || {};
							var data = {
								filter: this.customFilters || (options.filter && options.filter.value),
								sort: options.sort.value,
								order: options.order,
								from: range.from,
								to: range.to,
								page: options.page,
								search:options.search
							};
					
							this.fetch({
								data: data,
								reset: true,
								killerId: options.killerId
							});
						}

						var TransactionCollection=require("OrderHistory.Collection");
						TransactionCollection.prototype.update=update;
						// TransactionCollection=require("Transaction.Collection");
						// TransactionCollection.prototype.update=update;

					}


				}

			}
		}
	}
);
